export default "__VITE_ASSET__DWqZEW$Y__"